import type { Group } from '@shared/types/common';

export const parseGroups = (groups?: Group[]) => {
  const groupsWithoutSpecialType = new Array(groups?.length || 0);
  let coachesGroup, withoutGroup;

  groups?.forEach((group) => {
    const specialType = group?.special_type;
    if (specialType) {
      if (specialType == 'coaches') {
        coachesGroup = group;
      }
      if (specialType == 'without_group') {
        withoutGroup = group;
      }
    } else {
      groupsWithoutSpecialType.push(group);
    }
  });

  return {
    groupsWithoutSpecialType,
    coachesGroup: coachesGroup as Group | undefined,
    withoutGroup: withoutGroup as Group | undefined,
  };
};
